<template>
  <Transition
    name="roll"
    mode="out-in"
  >
    <slot />
  </Transition>
</template>

<style scoped>
.roll-enter-active, .roll-leave-active {
  transition: transform 0.5s ease, opacity 0.5s ease;
  display: block;
}
.roll-enter-from {
  transform: translateY(100%);
  opacity: 0;
}
.roll-enter-to {
  transform: translateY(0%);
  opacity: 1;
}
.roll-leave-from {
  transform: translateY(0%);
  opacity: 1;
}
.roll-leave-to {
  transform: translateY(-100%);
  opacity: 0;
}
</style>
